import type { MockScore, UUID } from './index';
export function scoreSummary(score: MockScore, minimum = 40, averageLine = 60) {
  const average = score.scores.reduce((sum, item) => sum + item.score, 0) / score.scores.length;
  return {
    average,
    risks: score.scores.filter((item) => item.score < minimum).map((item) => item.subjectId),
    averageRisk: average < averageLine,
  };
}
export function scoreTrend(scores: readonly MockScore[], examId: UUID) {
  return scores
    .filter((score) => score.examId === examId && !score.deletedAt)
    .sort((a, b) => a.studyDate.localeCompare(b.studyDate))
    .slice(-3)
    .map((score) => ({ id: score.id, title: score.title, average: scoreSummary(score).average }));
}
